import * as Icons from "lucide-react";

const isPdf = (u) => /\.pdf(\?|$)/i.test(String(u).split("?")[0]) || String(u).includes("%2Fpdf");

// Multiple ID document uploads (front/back, extra pages). Stored as kyc.id_doc_urls[]; kyc.id_doc_url = first.
export function KycDocs({ urls, onAdd, onRemove, uploading }) {
  return (
    <div className="mt-3" data-testid="kyc-docs">
      <div className="flex flex-wrap gap-2">
        {urls.map((u, i) => (
          <div key={u} className="relative h-20 w-20 rounded-lg border border-border bg-secondary overflow-hidden group" data-testid={`kyc-doc-${i}`}>
            {isPdf(u)
              ? <a href={u} target="_blank" rel="noreferrer" className="h-full w-full flex flex-col items-center justify-center text-xs text-muted-foreground"><Icons.FileText className="h-6 w-6" />PDF</a>
              : <a href={u} target="_blank" rel="noreferrer"><img src={u} alt={`ID ${i + 1}`} className="h-full w-full object-cover" /></a>}
            <button type="button" onClick={() => onRemove(u)} className="absolute top-1 right-1 h-5 w-5 rounded-full bg-black/60 text-white flex items-center justify-center opacity-80 hover:opacity-100" data-testid={`kyc-doc-remove-${i}`}><Icons.X className="h-3 w-3" /></button>
          </div>
        ))}
        <label className="h-20 w-20 rounded-lg border border-dashed border-border flex flex-col items-center justify-center text-[11px] text-muted-foreground cursor-pointer hover:bg-accent text-center" data-testid="kyc-upload-label">
          <Icons.Plus className="h-5 w-5" />{uploading ? "Uploading…" : urls.length ? "Add more" : "Upload ID"}
          <input type="file" multiple accept="image/*,application/pdf" className="hidden" data-testid="kyc-upload"
            onChange={(e) => { onAdd(Array.from(e.target.files || [])); e.target.value = ""; }} />
        </label>
      </div>
      <p className="text-[11px] text-muted-foreground mt-1.5" data-testid="kyc-doc-count">{urls.length} document{urls.length === 1 ? "" : "s"} · front, back and extra pages allowed (images or PDF)</p>
    </div>
  );
}
